import { render, staticRenderFns } from "./CBadge.vue?vue&type=template&id=03adbda0&scoped=true&"
import script from "./CBadge.vue?vue&type=script&lang=ts&"
export * from "./CBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03adbda0",
  null
  
)

export default component.exports